import { CIcon } from '~/icons/types'

export const ciYacht: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.443 11.171a.488.488 0 0 0-.445-.13l-3.585.715-1.6-1.949a.5.5 0 0 0-.386-.183h-1.1l-1.27-2.537a.5.5 0 0 0-.446-.276h-1.1l-1.265-2.534A.5.5 0 0 0 11.798 4H4.767a.5.5 0 0 0 0 1h1.1l.906 1.812H3.36a.5.5 0 0 0-.5.5v1.406a1.909 1.909 0 0 0 1.906 1.907h.65l-1.81 4.285-.147.03a3.4 3.4 0 0 0-2.541 2.2l-.89 2.671a.5.5 0 0 0 .475.658h17.566a4.79 4.79 0 0 0 4.7-3.943l.819-4.912a.5.5 0 0 0-.144-.443ZM11.49 4.999l.9 1.812H7.888l-.906-1.812h4.508Zm-4.856 5.319a.5.5 0 0 0-.461-.694H4.767a.907.907 0 0 1-.906-.907v-.906h10.437l.907 1.813h-6.22a.5.5 0 1 0 0 1h8.2l1.113 1.353-13.506 2.7 1.842-4.359Zm15.149 6.043a3.782 3.782 0 0 1-3.715 3.107H1.198l.67-2.012a2.383 2.383 0 0 1 1.788-1.537l18.83-3.756-.703 4.198Z'
    },
    {
      d:
        'M13.262 16.525a.774.774 0 1 0 0-1.548.774.774 0 0 0 0 1.548Zm2.743 0a.774.774 0 1 0 0-1.548.774.774 0 0 0 0 1.548Zm2.743 0a.774.774 0 1 0-.002-1.548.774.774 0 0 0 .002 1.548Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'yacht',
  type: 'thin'
}
